import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ToastMessageService {

  constructor(
    private _MessageService: MessageService
  ) { }

  public toastOnSuccess(title: string, message: string) {
    this._MessageService.add({
      severity: 'success',
      summary: title,
      detail: message
    })
  }

  public toastOnError(title: string, message: string) {
    this._MessageService.add({
      severity: 'error',
      summary: title,
      detail: message
    })
  }

}
